import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
  Card,
  Checkbox,
  Col,
  InputNumber,
  List,
  notification,
  Row,
  Space,
  Tabs,
  Image,
  Popconfirm,
  Button,
  Form,
  Divider,
} from 'antd';
import Meta from 'antd/lib/card/Meta';
import {
  AssetCatalogResponse,
  duplicateAssetCatalog,
  getAssetCatalogByID,
  // getAssetCatalogByID,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from 'services/assetconfig';
import { toCurrency, toRate } from 'utils/utils';
import ModalController from 'components/ModalController';
import { FormInstance } from 'antd/lib/form/Form';
import VirtualList from 'rc-virtual-list';
import { AuthContext } from 'components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import DuplicateButtonAction from 'components/DuplicatButtonAction';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import IActions from 'icons/IActions';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import { shouldUpdateCompare } from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import InputCurrency from 'components/InputCurrency';
import { isNil, sumBy } from 'lodash';
import AssetDetails from 'pages/Asset/AssetDetail';
// import { CloseOutlined } from '@ant-design/icons';
import DeleteButton from 'components/DeleteButton';
import DataGrid from 'components/DataGrid';
import { ParServiceResponse } from 'services/pricing';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import SliderWithInputAndPercentage from 'components/SliderWithInputAndPercentage';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import AssetCatalogDetailsModal from 'pages/Configuration/AssetCatalog/AssetCatalogDetailsModal';
import SliderWithInput from 'components/SliderWithInput';
import SplitAssetButton from './components/SplitAssetButton';
import { loadFileAsResource } from 'services/Document';
// import ElementsTable from './ElementsTable';

const { TabPane } = Tabs;

export type AssetCardProps = {
  item: any;
  form: FormInstance;
  myCatalog?: boolean;
  refetch?: any;
  hideServiceAndOptions?: boolean;
  debouncedCalculateNew: any;
  phase: 'PROD' | 'PROPOSAL';
  ctstatus?: string;
  ctrid?: number;
  fromproposal?: boolean;
  proposalData?: any;
  handleConvertServToFinServ: any;
  handleDeleteElement: any;
  record: any;
  onSelect: (
    item: AssetCatalogResponse,
    nbasset: number,
    selectedServices: ParAssetCatalogServiceResponse[],
    selectedOption: ParAssetCatalogOptionResponse[],
    fromCatalogMulticomponents: boolean
  ) => void;
  onSaveAsset?: (asset: any) => void;

  onSelectOptions: (
    option: any,
    cteid: number,
    assetid: number,
    operation: string
  ) => void;
  onSelectServices: (
    service: any,
    cteid: number,
    assetid: number,
    operation: string
  ) => void;
};

const AssetCard = (props: AssetCardProps) => {
  const {
    item,
    myCatalog,
    refetch,
    record,
    hideServiceAndOptions,
    form,
    debouncedCalculateNew,
    phase,
    ctrid,
    ctstatus,
    fromproposal,
    proposalData,
    handleConvertServToFinServ,
    handleDeleteElement,
    onSelect,
    onSelectServices,
    onSelectOptions,
    onSaveAsset,
  } = props;

  const { isInspect } = useContext(AuthContext);
  const history = useHistory();
  const [ImageBase64, setImageBase64] = useState<string>('');
  let listAsset = item;

  useEffect(() => {
    loadFileAsResource({ filename: item.assetpictureurl }).then((result) => {
      setImageBase64(result.description);
    });
  }, [item]);

  // eslint-disable-next-line no-unused-vars
  const [Asset, setAsset] = useState<any>([]);
  const [nbasset, setnbasset] = useState(1);

  const getName = (param: string, cteid: any) => {
    let lcteid = cteid;

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item?.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  const getHelper = (param: string, cteid: any) => {
    let lcteid = form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, 'helpers', param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, 'helpers', param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  const [coef, setCoef] = useState(0);

  useEffect(() => {
    let _coef = record.ctefinancedamount / item.assetfinamount;

    setCoef(_coef);

    const cteduration = form.getFieldValue(getName('cteduration', item.cteid));
    const ctemileage = form.getFieldValue(getName('ctemileage', item.cteid));

    if (cteduration && ctemileage !== undefined && phase!=='PROD') {
      const newRvAmount = getRvByDurationAndMileage(
        cteduration,
        Number(ctemileage)
      );

      form.setFieldValue(getName('ctervamount', item.cteid), newRvAmount);
    }
  }, [form, item]);

  // useEffect(() => {
  //   if (item.catalogid) {
  //     handlePreviewCATALOG(item.catalogid);
  //   }
  // }, [item.catalogid]);

  const handlePreviewCATALOG = (catalogid: number) => {
    getAssetCatalogByID({
      catalogid: catalogid,
    })
      .then((response) => {
        if (response.code === '200') {
          setAsset(response.data);
        } else {
          notification.error({
            message: response.message,
          });
        }
      })
      .catch((response) => {
        notification.error({
          message: response.message,
        });
      });
  };

  const [activeKey, setActiveKey] = useState('1');

  // const getRvByDurationAndMileage=(duration:number,mileage:number) =>{
  //   let mileagelist=item?.listMarksMillageByDuration?.find(
  //     (e: any) => e.duration === duration
  //   );

  //   let rvAmount=0;

  //   rvAmount=mileagelist?.find(
  //     (e: any) => e.mileage === mileage
  //   )?.rvamount;

  //   // if (rvAmount===null) {
  //   //   // get min :
  //   //   let min=mileagelist?.find((e:any)=>e.mileage<=mileage).max(_mileage)
  //   //   // get max :
  //   //   let max=mileagelist?.find((e:any)=>e.mileage>=mileage).min(_mileage)
  //   //   // calculate "pas" : (min.rvamount - max.rvamount) / (min.mileagemin-max.mileagemin)
  //   //   let pas=(min.rvamount - max.rvamount) / (min.mileagemin-max.mileagemin)
  //   //   rvAmount = pas *(mileage-min.mileagemin)+min.rvamount;

  //   // }

  //   return rvAmount;
  // }

  const getRvByDurationAndMileage = (duration: number, mileage: number) => {
    let rvAmount = 0;

    // Step 1: Find the mileage list for the given duration (if it exists)
    const mileageListForGivenDuration = item.listrv.find(
      (e: any) => e.duration === duration
    );

    let selectedDurationData = mileageListForGivenDuration;

    // Step 2: If the given duration doesn't exist, find the closest duration
    if (!selectedDurationData) {
      const findClosestDuration = (
        duration: number,
        listMarksMillageByDuration: any[]
      ) => {
        if (listMarksMillageByDuration.length === 0) return null;

        let closest = listMarksMillageByDuration[0];
        let minDifference = Math.abs(duration - closest.duration);

        for (let i = 1; i < listMarksMillageByDuration.length; i++) {
          const current = listMarksMillageByDuration[i];
          const difference = Math.abs(duration - current.duration);

          if (difference < minDifference) {
            closest = current;
            minDifference = difference;
          }
        }

        return closest;
      };

      selectedDurationData = findClosestDuration(
        duration,
        item.listMarksMillageByDuration
      );
    }

    const selectedDuration = selectedDurationData?.duration;

    // Step 3: Search in listrv using the selected duration
    const listByDuration = item.listrv.filter(
      (e: any) => e.monthsmin === selectedDuration
    );

    // Step 4: Find the nearest RV amounts
    const minList = listByDuration.filter((e: any) => e.mileagemin <= mileage);
    const min =
      minList.length > 0
        ? minList.reduce((prev: any, curr: any) =>
            prev.mileagemin > curr.mileagemin ? prev : curr
          )
        : null;

    const maxList = listByDuration.filter((e: any) => e.mileagemax >= mileage);
    const max =
      maxList.length > 0
        ? maxList.reduce((prev: any, curr: any) =>
            prev.mileagemax < curr.mileagemax ? prev : curr
          )
        : null;

    // Calculate the step (pas) for interpolation
    if (min && max && min.mileagemin !== max.mileagemin) {
      const restRvAmount = max.rvamount - min.rvamount;
      const restMileage = max.mileagemin - min.mileagemin;
      const pas = restRvAmount / restMileage;

      // Interpolate rvAmount
      rvAmount = pas * (mileage - min.mileagemin) + min.rvamount;
    } else if (min) {
      rvAmount = min.rvamount;
    } else if (max) {
      rvAmount = max.rvamount;
    }

    return rvAmount;
  };

  const getMarksMillage = (duration: number) => {
    let marks: any = item?.listMarksMillageByDuration?.find(
      (e: any) => e.duration === duration
    );

    return marks;
  };

  const resetFields = () => {
    const values = form.getFieldsValue();
    const pathsToReset: string[][] = [];

    for (const key in values) {
      if (
        key !== 'prcode' &&
        key !== 'client' &&
        key !== 'offerid' &&
        !key.startsWith('elements')
      ) {
        pathsToReset.push([key]);
      }
    }

    form.resetFields(pathsToReset);
  };

  //   let listMillageByDuration = item.listrv.filter(
  //     (rv: any) => rv.monthsmin === duration || rv.monthsmax === duration
  //   );

  //   let listOfMillageMin: number[] = listMillageByDuration.map(
  //     (rv: any) => rv.mileagemin
  //   );
  //   let listOfMillageMax: number[] = listMillageByDuration.map(
  //     (rv: any) => rv.mileagemax
  //   );

  //   let _listDistinct: number[] = _.uniq([
  //     ...listOfMillageMin,
  //     ...listOfMillageMax,
  //   ]);

  //   setMaxMillage(Math.max(..._listDistinct));
  //   setMinMillage(Math.min(..._listDistinct));
  // };

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      let listOptions = '';
      for (const i in selectedRows) {
        listOptions = selectedRows[i].associd + `,` + listOptions;
        form.setFieldsValue({
          row: Number(i),
        });
      }

      selectedRows.forEach((row: any, index: number) => {
        form.setFieldsValue({
          associd: row.associd,
        });
      });
    },
  };

  const columns = useMemo<DataGridColDef<ParServiceResponse>[]>(
    () => [
      {
        dataIndex: phase === 'PROD' || !isNil(ctrid) ? 'servcode' : 'servlabel',
        width: 250,
      },

      // {
      //   dataIndex: 'servcalculationmethodlabel',
      //   width: 120,
      // },

      {
        dataIndex: 'servfixedamount',
        width: 250,
        render: (value) => toCurrency(value),
      },

      {
        dataIndex: 'servpercentage',
        width: 250,
        render: (value) => toRate(value),
      },

      // {
      //   dataIndex: 'servduration',
      //   width: 120,
      // },

      // {
      //   dataIndex: 'flagSelected',
      //   render: (val) => String(val),
      //   width: 250,
      // },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, refetch]
  );

  const [selectedServices, setSelectedServices] = useState<string[]>(
    () => item?.assetServiceList?.map((serv: any) => serv.servcode) || []
  );

  const handleServiceSelection = (checked: boolean, record: any) => {
    const updatedRecord = { ...record, flagSelected: checked };

    let updatedSelectedServices = [...selectedServices];

    if (checked) {
      updatedSelectedServices.push(record.servcode);
      onSelectServices(updatedRecord, item.cteid, item.assetid, 'ADD');
    } else {
      updatedSelectedServices = updatedSelectedServices.filter(
        (servcode) => servcode !== record.servcode
      );
      onSelectServices(updatedRecord, item.cteid, item.assetid, 'DELETE');
    }

    setSelectedServices(updatedSelectedServices);
  };

  return (
    <Card
      style={{
        alignContent: 'center',
        boxShadow: '0px 0px 7px rgb(0 0 0 / 9%)',
        borderStyle: 'dashed',
        borderWidth: '2px',
      }}
    >
      <Row gutter={2}>
        <Col span={7}>
          <FinancialScheduleModal
            currcode={form?.getFieldValue('currcode')}
            finElement={record}
            comcode="finSchedule"
            controller={
              <ScheduleButton
                size="large"
                comcode="finSchedule"
                twoToneColor="blue"
              ></ScheduleButton>
            }
          />

          {Number(ctrid)! > 0 && item?.assetqty && item?.assetqty > 1 && (
            <SplitAssetButton
              assetid={item.assetid}
              comcode="split"
              ctrid={Number(ctrid)!}
              qty={item.assetqty}
              disabled
            />
          )}
          <Tabs
            activeKey={activeKey}
            centered
            onChange={(e) => {
              setActiveKey(e);
            }}
            tabBarExtraContent={
              myCatalog && (
                <TasksListPopover
                  entityId={item?.catalogid}
                  entityReference={'ID : ' + item?.catalogid}
                  entityName="CATALOG"
                  title={item.assetlabel}
                  onClose={() => {
                    refetch && refetch();
                  }}
                >
                  <Button
                    icon={<IActions height="15px" width="15px" />}
                    size="middle"
                  ></Button>
                </TasksListPopover>
              )
            }
          >
            <TabPane tab="Asset" key="1" animated>
              <Row justify="center">
                <Card
                  className="cardcatalog"
                  bordered={false}
                  style={{
                    borderRadius: '5px',
                  }}
                  title={
                    <strong>
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <a onClick={() => setVisible(true)}>
                            {listAsset?.assetlabel}
                          </a>
                        )}
                        modal={({ setVisible, visible }) => (
                          <AssetDetails
                            assetid={listAsset.assetid}
                            asset={listAsset}
                            onCancel={() => setVisible(false)}
                            showAsModal
                            display
                            isproposalcreate={isNil(ctrid)}
                            visible={visible}
                            phaseprop={
                              listAsset.assetstatus === 'REMARK'
                                ? 'PROD'
                                : phase
                            }
                            onSave={(asset) => {
                              setVisible(false);
                              onSaveAsset && onSaveAsset(asset);
                            }}
                            flagreal={listAsset.flagreal}
                            fromproposal={fromproposal}
                            proposalData={proposalData}
                            ctstatus={ctstatus}
                          />
                        )}
                      />
                    </strong>
                  }
                  cover={
                    <ModalControllerNV
                      content={({ setVisible, visible }) => (
                        <Image
                          preview={{ visible: false }}
                          src={
                            'data:image/jpeg;charset=utf-8;base64, ' +
                            ImageBase64
                          }
                          style={{
                            height: '180px',
                          }}
                          onClick={(e) => {
                            setVisible(true);
                            e.stopPropagation();
                            handlePreviewCATALOG(
                              Number(item?.assetCatalog?.catalogid)
                            );
                          }}
                        />
                      )}
                      modal={({ setVisible, visible }) => (
                        <AssetCatalogDetailsModal
                          visible={visible}
                          onCancel={() => setVisible(false)}
                          title={item.assetlabel}
                          catalogid={Number(item?.assetCatalog?.catalogid)}
                        />
                      )}
                    />
                  }
                  actions={[
                    !myCatalog && (
                      <Row>
                        <div>
                          <GetLabel label="quantity" />:{' '}
                          <InputNumber
                            key={2}
                            size="middle"
                            value={item.assetqty ?? 1}
                            min={1}
                            max={100}
                            disabled={phase === 'PROD'}
                            onChange={(nb: number | any) => {
                              let assets = form.getFieldValue('assets');

                              item.assetqty = nb;

                              let netamount = 0;
                              let assetrvamount = 0;

                              assets.forEach((asset: any) => {
                                if (asset.assetid === item.assetid) {
                                  asset.assetqty = nb;

                                  netamount =
                                    Number(nb || 1) *
                                    Number(asset.assetunitnetamount || 0);
                                  asset.assettaxamount =
                                    (netamount * item.taxrate) / 100;
                                  asset.assetnetamount = netamount;
                                  asset.assetgrossamount =
                                    netamount + asset.assettaxamount;

                                  assetrvamount = asset.assetrvamount;
                                }
                              });

                              let elements = form.getFieldValue('elements');

                              const { FIN, SERV, FEES } = elements;

                              const SERVLIST: any[] = Array.isArray(SERV)
                                ? SERV
                                : [];

                              const FEESLIST: any[] = Array.isArray(FEES)
                                ? FEES
                                : [];

                              [...SERVLIST, ...FEESLIST].forEach((el) => {
                                if (el.cteidparent === record.cteid) {
                                  if (isNil(el.servfixedamountinit)) {
                                    el.servfixedamountinit = el.servfixedamount;
                                  }
                                  el.servfixedamount =
                                    el.servfixedamountinit * nb;
                                }
                              });

                              FIN?.forEach((element: any) => {
                                if (record.cteid === element.cteid) {
                                  element.cteinitialamount = netamount;

                                  element.cteinvestamount = netamount;

                                  element.ctervamount = assetrvamount * nb;

                                  element.ctestartamount = netamount;
                                  element.ctefinancedamount = netamount;

                                  element.totalAmortization = netamount;
                                }
                              });

                              form.setFieldValue('ctfinancedamount', netamount);

                              form.setFieldValue('elements', {
                                ...elements,
                                FIN: FIN,
                                SERV: SERVLIST,
                                FEES: FEESLIST,
                              });
                              form.setFieldValue('assets', assets);

                              debouncedCalculateNew('RV', '', item.cteid);
                            }}
                            style={{ width: '40%', float: 'right' }}
                          />
                        </div>
                      </Row>
                    ),
                  ]}
                >
                  <Meta
                    title={
                      <>
                        <div>&nbsp;</div>
                        <Row>
                          <div>
                            <strong style={{ fontSize: '17px' }}>
                              <GetLabel label="ctefinancedamount" />:{' '}
                            </strong>
                            <strong
                              style={{
                                marginRight: '2%',
                                fontSize: '17px',
                                textAlign: 'center',
                                color: 'red',
                              }}
                            >
                              {toCurrency(
                                Number(
                                  form.getFieldValue(
                                    getName('ctefinancedamount', item.cteid)
                                  )
                                ),
                                localStorage.getItem('currcode') ?? ''
                              )}
                            </strong>
                          </div>
                        </Row>
                        <Row>
                          <div>
                            <strong style={{ fontSize: '17px' }}>
                              <GetLabel label="cterentalamount" />:{' '}
                            </strong>
                            <strong
                              style={{
                                marginRight: '2%',
                                fontSize: '17px',
                                textAlign: 'center',
                                color: 'red',
                              }}
                            >
                              {toCurrency(
                                form.getFieldValue(
                                  getName('cterentalamount', item.cteid)
                                ) ?? 0,
                                localStorage.getItem('currcode') ?? ''
                              )}
                            </strong>
                          </div>
                        </Row>
                        <Row>
                          <div>
                            <strong style={{ fontSize: '17px' }}>
                              <GetLabel label="cterentalamountincserv" />:{' '}
                            </strong>

                            <Form.Item shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                const cterentalamount =
                                  getFieldValue(
                                    getName('cterentalamount', item.cteid)
                                  ) || 0;

                                let elements = form.getFieldValue('elements');

                                const { SERV } = elements;

                                const SERVLIST: any[] = Array.isArray(SERV)
                                  ? SERV
                                  : [];

                                const servAferFilter = [...SERVLIST].filter(
                                  (el) => el.cteidparent === record.cteid
                                );

                                const cterentalamountincserv = sumBy(
                                  servAferFilter,
                                  'cterentalamount'
                                );

                                return (
                                  <strong
                                    style={{
                                      marginRight: '2%',
                                      fontSize: '17px',
                                      textAlign: 'center',
                                      color: 'red',
                                    }}
                                  >
                                    {toCurrency(
                                      cterentalamount / coef +
                                        cterentalamountincserv,
                                      localStorage.getItem('currcode') ?? ''
                                    )}
                                  </strong>
                                );
                              }}
                            </Form.Item>
                          </div>
                        </Row>
                      </>
                    }
                  />
                </Card>
              </Row>
            </TabPane>
            {!hideServiceAndOptions && (
              <TabPane tab="Options" key="3">
                <Row justify="center">
                  <Card
                    bordered={false}
                    className="cardcatalog"
                    style={{
                      borderRadius: '5px',
                    }}
                    title={
                      <strong>
                        <ModalControllerNV
                          content={({ setVisible, visible }) => (
                            <a onClick={() => setVisible(true)}>
                              {listAsset?.assetlabel}
                            </a>
                          )}
                          modal={({ setVisible, visible }) => (
                            <AssetDetails
                              assetid={listAsset.assetid}
                              asset={listAsset}
                              onCancel={() => setVisible(false)}
                              showAsModal
                              display
                              isproposalcreate={isNil(ctrid)}
                              visible={visible}
                              phaseprop={
                                listAsset.assetstatus === 'REMARK'
                                  ? 'PROD'
                                  : phase
                              }
                              onSave={(asset) => {
                                setVisible(false);
                                onSaveAsset && onSaveAsset(asset);
                              }}
                              flagreal={listAsset.flagreal}
                              fromproposal={fromproposal}
                              proposalData={proposalData}
                              ctstatus={ctstatus}
                            />
                          )}
                        />
                      </strong>
                    }
                    cover={
                      <ModalController>
                        {({ setVisible, visible }) => (
                          <>
                            <Image
                              preview={{ visible: false }}
                              src={
                                'data:image/jpeg;charset=utf-8;base64, ' +
                                ImageBase64
                              }
                              style={{ height: '180px' }}
                              onClick={(e) => {
                                setVisible(true);
                                e.stopPropagation();
                                // myCatalog
                                //   ? history.push(
                                //       `/configuration/asset-catalog/${item.catalogid}/catalog`
                                //     )
                                //   // : handlePreviewCATALOG(
                                //   //     Number(listAsset?.catalogid)
                                //   //   );
                              }}
                            />
                            <AssetDetails
                              assetid={listAsset.assetid}
                              asset={listAsset}
                              onCancel={() => setVisible(false)}
                              showAsModal
                              display
                              isproposalcreate={isNil(ctrid)}
                              visible={visible}
                              phaseprop={
                                listAsset.assetstatus === 'REMARK'
                                  ? 'PROD'
                                  : phase
                              }
                              onSave={(asset) => {
                                setVisible(false);
                                onSaveAsset && onSaveAsset(asset);
                              }}
                              flagreal={listAsset.flagreal}
                              fromproposal={fromproposal}
                              proposalData={proposalData}
                              ctstatus={ctstatus}
                            />
                          </>
                        )}
                      </ModalController>
                    }
                    actions={[
                      !myCatalog && (
                        <div>
                          <GetLabel label="quantity" />:{' '}
                          <InputNumber
                            key={2}
                            size="middle"
                            value={item.assetqty ?? 1}
                            min={1}
                            max={100}
                            disabled={phase === 'PROD'}
                            onChange={(nb: number | any) => {
                              let assets = form.getFieldValue('assets');

                              item.assetqty = nb;

                              let netamount = 0;
                              let assetrvamount = 0;

                              assets.forEach((asset: any) => {
                                if (asset.assetid === item.assetid) {
                                  asset.assetqty = nb;

                                  netamount =
                                    Number(nb || 1) *
                                    Number(asset.assetunitnetamount || 0);
                                  asset.assettaxamount =
                                    (netamount * item.taxrate) / 100;
                                  asset.assetnetamount = netamount;
                                  asset.assetgrossamount =
                                    netamount + asset.assettaxamount;

                                  assetrvamount = asset.assetrvamount;
                                }
                              });

                              let elements = form.getFieldValue('elements');

                              const { FIN, SERV, FEES } = elements;

                              const SERVLIST: any[] = Array.isArray(SERV)
                                ? SERV
                                : [];

                              const FEESLIST: any[] = Array.isArray(FEES)
                                ? FEES
                                : [];

                              [...SERVLIST, ...FEESLIST].forEach((el) => {
                                if (el.cteidparent === record.cteid) {
                                  if (isNil(el.servfixedamountinit)) {
                                    el.servfixedamountinit = el.servfixedamount;
                                  }
                                  el.servfixedamount =
                                    el.servfixedamountinit * nb;
                                }
                              });

                              FIN?.forEach((element: any) => {
                                if (record.cteid === element.cteid) {
                                  element.cteinitialamount = netamount;

                                  element.cteinvestamount = netamount;

                                  element.ctervamount = assetrvamount * nb;

                                  element.ctestartamount = netamount;
                                  element.ctefinancedamount = netamount;

                                  element.totalAmortization = netamount;
                                }
                              });

                              form.setFieldValue('ctfinancedamount', netamount);

                              form.setFieldValue('elements', {
                                ...elements,
                                FIN: FIN,
                                SERV: SERVLIST,
                                FEES: FEESLIST,
                              });
                              form.setFieldValue('assets', assets);

                              debouncedCalculateNew('RV', '', item.cteid);
                            }}
                            style={{ width: '40%', float: 'right' }}
                          />
                        </div>
                      ),
                    ]}
                  >
                    {item?.assetCatalog?.assetCatalogOptions?.length > 0 && (
                      <List>
                        <VirtualList
                          data={item?.assetCatalog?.assetCatalogOptions ?? []}
                          height={120}
                          itemKey="id"
                          itemHeight={20}
                        >
                          {(e: any) => (
                            <List.Item>
                              <Checkbox
                                value={e.optvalue}
                                disabled={phase === 'PROD'}
                                onChange={(a) => {
                                  if (a.target.checked) {
                                    onSelectOptions(
                                      e,
                                      item.cteid,
                                      item.assetid,
                                      'ADD'
                                    );
                                  } else {
                                    onSelectOptions(
                                      e,
                                      item.cteid,
                                      item.assetid,
                                      'DELETE'
                                    );
                                  }
                                  debouncedCalculateNew('', '', item.cteid);
                                }}
                                checked={
                                  item?.assetComponents?.findIndex(
                                    (comp: any) => comp.compid === e.optid
                                  ) > -1
                                    ? true
                                    : false
                                }
                              >
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                  }}
                                >
                                  <Col>
                                    {e.optcodelabel +
                                      ' : ' +
                                      e.optvaluelabel +
                                      ' : ' +
                                      toCurrency(e.optnetamount, item.currcode)}
                                  </Col>
                                </div>
                              </Checkbox>
                            </List.Item>
                          )}
                        </VirtualList>
                      </List>
                    )}
                    <Meta
                      title={
                        <>
                          <div>&nbsp;</div>
                          <Row>
                            <div>
                              <strong style={{ fontSize: '17px' }}>
                                <GetLabel label="ctefinancedamount" />:{' '}
                              </strong>
                              <strong
                                style={{
                                  marginRight: '2%',
                                  fontSize: '17px',
                                  textAlign: 'center',
                                  color: 'red',
                                }}
                              >
                                {toCurrency(
                                  Number(
                                    form.getFieldValue(
                                      getName('ctefinancedamount', item.cteid)
                                    )
                                  ),
                                  localStorage.getItem('currcode') ?? ''
                                )}
                              </strong>
                            </div>
                          </Row>
                          <Row>
                            <div>
                              <strong style={{ fontSize: '17px' }}>
                                <GetLabel label="cterentalamount" />:{' '}
                              </strong>
                              <strong
                                style={{
                                  marginRight: '2%',
                                  fontSize: '17px',
                                  textAlign: 'center',
                                  color: 'red',
                                }}
                              >
                                {toCurrency(
                                  form.getFieldValue(
                                    getName('cterentalamount', item.cteid)
                                  ) ?? 0,
                                  localStorage.getItem('currcode') ?? ''
                                )}
                              </strong>
                            </div>
                          </Row>
                          <Row>
                            <div>
                              <strong style={{ fontSize: '17px' }}>
                                <GetLabel label="cterentalamountincserv" />:{' '}
                              </strong>

                              <Form.Item shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const cterentalamount =
                                    getFieldValue(
                                      getName('cterentalamount', item.cteid)
                                    ) || 0;

                                  let elements = form.getFieldValue('elements');

                                  const { SERV } = elements;

                                  const SERVLIST: any[] = Array.isArray(SERV)
                                    ? SERV
                                    : [];

                                  const servAferFilter = [...SERVLIST].filter(
                                    (el) => el.cteidparent === record.cteid
                                  );

                                  const cterentalamountincserv = sumBy(
                                    servAferFilter,
                                    'cterentalamount'
                                  );

                                  return (
                                    <strong
                                      style={{
                                        marginRight: '2%',
                                        fontSize: '17px',
                                        textAlign: 'center',
                                        color: 'red',
                                      }}
                                    >
                                      {toCurrency(
                                        cterentalamount / coef +
                                          cterentalamountincserv,
                                        localStorage.getItem('currcode') ?? ''
                                      )}
                                    </strong>
                                  );
                                }}
                              </Form.Item>
                            </div>
                          </Row>
                        </>
                      }
                      description={
                        myCatalog && (
                          <Space
                            direction="horizontal"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <Col
                              style={{ marginTop: '3px' }}
                              onKeyPress={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <Popconfirm
                                title="Sure to duplicate?"
                                onConfirm={(e: any) => {
                                  e.stopPropagation();
                                  !isInspect &&
                                    duplicateAssetCatalog({
                                      catalogid: item?.catalogid,
                                      catalogidorigine: 0,
                                      isnewVersion: false,
                                    }).then((res) => {
                                      history.push(
                                        `/configuration/asset-catalog/${res.data.catalogid}/catalog`
                                      );
                                      notification.success({
                                        message: res.message,
                                      });
                                      //refetch();
                                    });
                                }}
                              >
                                <DuplicateButtonAction comcode="duplicate" />
                              </Popconfirm>
                            </Col>
                            <Col style={{ marginTop: '3px' }}>
                              <Popconfirm
                                title="Sure to create a new version ?"
                                onConfirm={() => {
                                  !isInspect &&
                                    duplicateAssetCatalog({
                                      catalogid: item?.catalogid,
                                      catalogidorigine:
                                        item?.catalogidorigine ??
                                        item?.catalogid,
                                      isnewVersion: true,
                                    }).then((res) => {
                                      history.push(
                                        `/configuration/asset-catalog/${res.data.catalogid}/catalog`
                                      );
                                      notification.success({
                                        message: res.message,
                                      });
                                      //refetch();
                                    });
                                }}
                              >
                                <DuplicateButtonAction comcode="newVersion" />
                              </Popconfirm>
                            </Col>
                          </Space>
                        )
                      }
                    />
                  </Card>
                </Row>
              </TabPane>
            )}
          </Tabs>
        </Col>
        <Divider
          type="vertical"
          style={{ backgroundColor: 'red', height: '100%' }}
        />
        <Col span={15}>
          <Row gutter={30} justify="center">
            <Col span={10}>
              <Form.Item shouldUpdate noStyle>
                <FormInput
                  comcode="cteduration"
                  name={getName('cteduration', item.cteid)}
                >
                  <SliderWithInput
                    widthInput={6}
                    max={
                      item?.durationList ? Math.max(...item.durationList) : 0
                    }
                    min={Math.min(...(item?.durationList || []))}
                    precision={0}
                    onChange={(e) => {
                      let _rvamount = getRvByDurationAndMileage(
                        Number(e),
                        form.getFieldValue(getName('ctemileage', item.cteid))
                      );
                      form.setFieldValue(
                        getName('ctervamount', item.cteid),
                        _rvamount
                      );

                      debouncedCalculateNew('RV', 'INST', item.cteid);
                    }}
                    disabled={phase === 'PROD'}
                    // onChange={(e) =>
                    //  {  //let object = getMarksMillage(Number(e));

                    //   let _rvamount = getRvByDurationAndMileage(form.getFieldValue(getName('ctemileage',item.cteid)),e);
                    //   /*item.listrv.find(
                    //     (i: any) => i.mileagemin === object.minMillage
                    //   )?.rvamount;
                    //   // setRvAmount(_rvamount);
                    //   */
                    //   form.setFieldValue(
                    //     getName('ctervamount', item.cteid),
                    //     _rvamount
                    //   );
                    //    debouncedCalculateNew('', 'INST')}}
                  />
                  {/* <Slider
                    marks={item.marksDuration}
                    min={Math.min(...(item?.durationList || []))}
                    onChange={(e) => {
                      // onchangeDuration(e);
                      // setselectedDuration(e);
                      let object = getMarksMillage(e);

                      let _rvamount = item.listrv.find(
                        (i: any) => i.mileagemin === object.minMillage
                      )?.rvamount;
                      // setRvAmount(_rvamount);

                      form.setFieldValue(
                        getName('ctervamount', item.cteid),
                        _rvamount
                      );

                      debouncedCalculateNew('RV', 'INST', item.cteid);
                    }}
                    max={
                      item?.durationList ? Math.max(...item.durationList) : 0
                    }
                    step={null}
                    included={false}
                  /> */}
                </FormInput>
              </Form.Item>
              {/* and select/set the first value */}
            </Col>
            <Col span={1} />
            <Col span={10}>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  let cteduration: number = getFieldValue(
                    getName('cteduration', item.cteid)
                  );

                  let object = getMarksMillage(cteduration);

                  return (
                    <FormInput
                      comcode="ctemileage"
                      name={getName('ctemileage', item.cteid)}
                      shouldUpdate
                    >
                      <SliderWithInput
                        max={object?.maxMillage}
                        min={object?.minMillage}
                        precision={0}
                        widthInput={6}
                        disabled={phase === 'PROD'}
                        onChange={(e) => {
                          /*  let _rvamount = item.listrv.find(
                            (i: any) => i.mileagemin === e
                          )?.rvamount;
                          */
                          console.log('e mileage::', e);
                          let _rvamount = getRvByDurationAndMileage(
                            form.getFieldValue(
                              getName('cteduration', item.cteid)
                            ),
                            Number(e)
                          );
                          /*item.listrv.find(
                        (i: any) => i.mileagemin === object.minMillage
                      )?.rvamount;
                      // setRvAmount(_rvamount);
                      */
                          form.setFieldValue(
                            getName('ctervamount', item.cteid),
                            _rvamount
                          );

                          let assets = form.getFieldValue('assets') ?? [];

                          assets.forEach((asset: any) => {
                            if (asset.assetid === item.assetid) {
                              asset.ctemileage = e;
                            }
                          });

                          form.setFieldValue('assets', assets);

                          debouncedCalculateNew('RV', 'INST', item.cteid);

                          // recalculate(selectedDuration, _rvamount);
                        }}
                      />
                      {/* <Slider
                        marks={object?.marks}
                        min={object?.minMillage}
                        max={object?.maxMillage}
                        onChange={(e) => {
                          let _rvamount = item.listrv.find(
                            (i: any) => i.mileagemin === e
                          )?.rvamount;
                          form.setFieldValue(
                            getName('ctervamount', item.cteid),
                            _rvamount
                          );

                          let assets = form.getFieldValue('assets') ?? [];

                          assets.forEach((asset: any) => {
                            if (asset.assetid === item.assetid) {
                              asset.ctemileage = e;
                            }
                          });

                          form.setFieldValue('assets', assets);

                          debouncedCalculateNew('RV', 'INST', item.cteid);

                          // recalculate(selectedDuration, _rvamount);
                        }}
                        step={null}
                        included={false}
                      /> */}
                    </FormInput>
                  );
                }}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <>
                    <FormInput
                      col
                      xs={8}
                      md={8}
                      comcode="ctepriidexceed"
                      name={getName('ctepriidexceed', item.cteid)}
                    >
                      <PricingListFilteredSelect
                        allowClear
                        disabled={phase === 'PROD'}
                        params={{
                          offerid: getFieldValue('offerid') ?? 0,
                          ctetype: 'ASSUSE',
                          prcode: getFieldValue('prcode') ?? '',
                          entity: '',
                          entityid: 0,
                          tpid: getFieldValue('client')?.tpid ?? 0,
                        }}
                      />
                    </FormInput>
                    <Col span={2} />
                    <FormInput
                      col
                      xs={8}
                      md={8}
                      comcode="supplier"
                      name="supplier"
                      // name={getName('supplier', item.cteid)}
                    >
                      <ThirdPartyInput
                        disabled={phase === 'PROD'}
                        role="SUPPLIER"
                      />
                    </FormInput>
                  </>
                );
              }}
            </Form.Item>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item shouldUpdate={shouldUpdateCompare('currcode')} noStyle>
                {({ getFieldValue }) => {
                  return (
                    <>
                      <Row gutter={10}>
                        <FormInput
                          col
                          xs={8}
                          md={8}
                          comcode="tpidparticipation"
                          name={getName('tpidparticipation', item.cteid)}
                        >
                          <ThirdPartyInput disabled={phase === 'PROD'} />
                        </FormInput>

                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            return (
                              <FormInput
                                col
                                xs={10}
                                md={10}
                                name={getName('ctepartmethod', item.cteid)}
                                comcode="ctepartmethod"
                              >
                                <ParListSelect
                                  parcode="CTEPARTMET"
                                  offerid={getFieldValue('offerid')}
                                  // onSelected={() =>
                                  //   debouncedCalculateNew('', '')
                                  // }
                                  disabled={phase === 'PROD'}
                                />
                              </FormInput>
                            );
                          }}
                        </Form.Item>

                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('currcode')}
                          noStyle
                        >
                          {({ getFieldValue }) => {
                            return (
                              <InputCurrency
                                col
                                md={6}
                                disabled={
                                  phase === 'PROD' ||
                                  getFieldValue(
                                    getName('ctepartmethod', item.cteid)
                                  ) === 'POURC'
                                }
                                currcode={getFieldValue('currcode')}
                                comcode="ctepartamount"
                                onChange={() =>
                                  debouncedCalculateNew(
                                    'PARTAMOUNT',
                                    'INST',
                                    item.cteid
                                  )
                                }
                                fieldname={getName('ctepartamount', item.cteid)}
                              />
                            );
                          }}
                        </Form.Item>
                      </Row>
                      <Row gutter={10}>
                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('currcode')}
                          noStyle
                        >
                          {({ getFieldValue }) => {
                            return (
                              <FormInput
                                style={{ color: 'blue' }}
                                col
                                xs={6}
                                md={6}
                                name={getName('ctefirstpayment', item.cteid)}
                                comcode="ctefirstpayment"
                              >
                                {/* {isNil(ctrid) || ctrid === 0 ? ( */}
                                <InputCurrency
                                  currcode={getFieldValue('currcode')}
                                  max={getFieldValue(
                                    getHelper('frmax', item.cteid)
                                  )}
                                  min={getFieldValue(
                                    getHelper('frmin', item.cteid)
                                  )}
                                  // defaultValue={100}
                                  value={100}
                                  step={1}
                                  onChange={() =>
                                    debouncedCalculateNew('FP', 'INST')
                                  }
                                  disabled={phase === 'PROD'}
                                />
                                {/* ) : (
                                  <strong>
                                    {toCurrency(
                                      form.getFieldValue(
                                        getName('ctefirstpayment', item.cteid)
                                      ) / coef,
                                      localStorage.getItem('currcode') ?? ''
                                    )}
                                  </strong>
                                )} */}
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                        <Form.Item shouldUpdate={() => true} noStyle>
                          {({ getFieldValue }) => {
                            {console.log('rvvvvvvvvvvvvv',getFieldValue(getName('ctervamount', item.cteid)))}
                            return(
                              <FormInput
                                col
                                xs={18}
                                md={18}
                                comcode="ctervamount"
                                name={getName('ctervamount', item.cteid)}
                              >
                                {/* {isNil(ctrid) || ctrid === 0 ? ( */}
                                <SliderWithInputAndPercentage
                                  currcode={getFieldValue('currcode')}
                                  max={getFieldValue(
                                    getHelper('rvmax', item.cteid)
                                  )}
                                  min={getFieldValue(
                                    getHelper('rvmin', item.cteid)
                                  )}
                                  basis={getFieldValue(
                                    getName('cteinvestamount', item.cteid)
                                  )}
                                  step={1}
                                  precisionAmount={2}
                                  precisionCoef={5}
                                  onChange={() => debouncedCalculateNew('')}
                                  hideSlider
                                  disabled={phase === 'PROD'}
                                />
                                {/* ) : (
                                  <strong>
                                    {toCurrency(
                                      form.getFieldValue(
                                        getName('ctervamount', item.cteid)
                                      ) / coef,
                                      localStorage.getItem('currcode') ?? ''
                                    )}
                                  </strong>
                                )} */}
                              </FormInput>
                          )}}
                        </Form.Item>
                      </Row>
                    </>
                  );
                }}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const SERV: any[] = Array.isArray(
                    getFieldValue(['elements', 'SERV'])
                  )
                    ? getFieldValue(['elements', 'SERV'])
                    : [];

                  const FEES: any[] = Array.isArray(
                    getFieldValue(['elements', 'FEES'])
                  )
                    ? getFieldValue(['elements', 'FEES'])
                    : [];

                  const elements = [...SERV, ...FEES].filter(
                    (e) =>
                      e.cteidparent === getFieldValue('selectedElement') &&
                      e.ctedirection === 'IN'
                  );

                  const obj = {
                    finschedule: form.getFieldValue(
                      getName('conElemSchedules', item)
                    ),
                    ctegraceperiodduration: form.getFieldValue(
                      getName('ctegraceperiodduration', item)
                    ),
                    ctefinancedamount: form.getFieldValue(
                      getName('ctefinancedamount', item)
                    ),
                    cteinvestamount: form.getFieldValue(
                      getName('ctefinancedamount', item)
                    ),
                    assetamount: form.getFieldValue(
                      getName('ctefinancedamount', item)
                    ),
                    ctestartdate: form.getFieldValue(
                      getName('ctestartdate', item)
                    ),
                    cteduration: form.getFieldValue(
                      getName('cteduration', item)
                    ),
                  };

                  let selectedServices = item?.assetServiceList?.map(
                    (serv: any) => serv.servcode
                  );
                  let services =
                    item?.assetCatalog?.assetCatalogServices?.filter(
                      (service: any) =>
                        item?.assetServiceList?.includes(service)
                    );
                  return (
                    <DataGrid
                      rowKey="servcode"
                      componentName="services_list"
                      columns={columns}
                      dataSource={
                        phase === 'PROD' || !isNil(ctrid)
                          ? item.assetServiceList
                          : item?.assetCatalog?.assetCatalogServices
                      }
                      titleComcode="serviceList"
                      hideExtraAction
                      rowSelection={{
                        hideSelectAll: true,
                        selectedRowKeys: selectedServices,
                        columnTitle: <GetLabel label="Services to Include" />,
                        columnWidth: '120px',
                        renderCell: (value: any, record) => (
                          <Checkbox
                            checked={
                              selectedServices.findIndex(
                                (servcode: string) =>
                                  servcode === record.servcode
                              ) > -1
                                ? true
                                : false
                            }
                            disabled={phase === 'PROD'}
                            onChange={(e) => {
                              handleServiceSelection(e.target.checked, record);
                              // const updatedRecord = { ...record, flagSelected: e.target.checked };
                              // if (e.target.checked) {
                              //   onSelectServices(
                              //     updatedRecord,
                              //     item.cteid,
                              //     item.assetid,
                              //     'ADD'
                              //   );
                              // } else {
                              //   onSelectServices(
                              //     updatedRecord,
                              //     item.cteid,
                              //     item.assetid,
                              //     'DELETE'
                              //   );
                              // }
                            }}
                          />
                        ),
                        // onSelect: (record: any) => {
                        //   onSelectServices(
                        //     record,
                        //     item.cteid,
                        //     item.assetid,
                        //     'ADD'
                        //   );
                        // },
                        // onChange(selectedRowKeys, selectedRows, info) {
                        //   let diff = _.difference(
                        //     item.assetServiceList.map(
                        //       (serv: any) => serv.servcode
                        //     ),
                        //     selectedRowKeys
                        //   );
                        //   let object =
                        //     item?.assetCatalog?.assetCatalogServices?.find(
                        //       (e: any) => e.servcode === diff[0]
                        //     );

                        //   if (
                        //     selectedRowKeys.length >
                        //     item.assetServiceList.length
                        //   ) {
                        //     // onSelectServices(
                        //     //   object,
                        //     //   item.cteid,
                        //     //   item.assetid,
                        //     //   'ADD'
                        //     // );
                        //   } else {
                        //     onSelectServices(
                        //       object,
                        //       item.cteid,
                        //       item.assetid,
                        //       'DELETE'
                        //     );
                        //   }
                        // },
                        // onSelect: (record) => setSelectedItem(record.filterid),
                      }}
                    />
                  );
                }}
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={1}>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={(e) => {
              resetFields();
              // form.resetFields();
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        </Col>
      </Row>
    </Card>
  );
};
export default AssetCard;
